import React from 'react';

/**
 * Section title component for consistent heading styling
 * @param {Object} props - Component props
 * @param {string} props.title - Main title text
 * @param {string} [props.subtitle] - Optional subtitle text
 * @param {string} [props.className] - Additional CSS classes
 * @param {string} [props.align='center'] - Text alignment (center, left, right)
 * @returns {React.ReactElement} SectionTitle component
 */
const SectionTitle = ({ 
  title, 
  subtitle, 
  className = '', 
  align = 'center' 
}) => {
  const alignmentClasses = {
    center: 'text-center',
    left: 'text-left',
    right: 'text-right',
  };

  return (
    <div className={`mb-2 sm:mb-4 md:mb-6 ${alignmentClasses[align]} ${className}`}>
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-2 sm:mb-3 tracking-wider">{title}</h2>
      {subtitle && (
        <p className="text-lg text-gray-400 max-w-3xl mx-auto">
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionTitle;
